import { css } from "@emotion/react";
import { Theme, useTheme } from "@mui/material";
import Link from "next/link";

import { Props } from "~/components/category/[id]/database/database-panel/index";
import { fixedHeight } from "~/lib/client/design";
import { formatDate } from "~/lib/graphql/graphqlClient";

const SpDatabasePanel = (props: Props) => {
  const theme = useTheme();

  return (
    <div css={rootStyle}>
      <div>
        {props.database.categories.map((c) => (
          <Link
            href={`/category/${c.id}`}
            css={categoryLinkStyle(theme)}
            key={`category-${c.id}`}
          >
            #{c.name}
          </Link>
        ))}
      </div>
      <Link href={`/database/${props.database.id}`}>
        <p css={databaseIdStyle}>#{props.database.id}</p>
        <p css={databaseTitleStyle}>{props.database.title}</p>
      </Link>
      <div id={"metadata-info"}>
        <div css={createdAtStyle(theme)}>
          {formatDate(props.database.createdAt)}
        </div>
        <div css={postSizeStyle(theme)}>
          投稿数 {props.database.postSize.toLocaleString()}
        </div>
      </div>
    </div>
  );
};

const rootStyle = css`
  background: white;
  width: 100%;
  ${fixedHeight(`calc(20rem - 2px)`)}
  padding: 1rem;
  border: 1px solid #eaeaea;
  border-radius: 0.25rem;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;

  position: relative;

  #metadata-info {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;

    margin: auto 0 0.25rem 0;
  }
`;

const categoryLinkStyle = (theme: Theme) => css`
  color: ${theme.palette.primary.main};
  font-size: 0.8rem;
`;

const databaseIdStyle = css`
  font-size: 1.25rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`;

const databaseTitleStyle = css`
  font-size: 1rem;
  font-weight: 600;
  ${fixedHeight("144px")}
  margin: 0;

  overflow: hidden;
  text-overflow: ellipsis;
`;

const createdAtStyle = (theme: Theme) => css`
  font-size: 0.7rem;
  color: ${theme.palette.text.secondary};
  margin: 0;
`;

const postSizeStyle = (theme: Theme) => css`
  font-size: 0.7rem;
  color: ${theme.palette.text.secondary};
  margin: 0;
  display: flex;
  justify-content: flex-end;
`;

export default SpDatabasePanel;
